module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-outright01.bbc86b0b.svg";